import bus from "../services/bus"

export default {
  data() {
    return {
      visible: false,
      color: null,
      text: null,
      timeout: 6000,
    }
  },

  methods: {
    show(color, text, timeout) {
      this.color = color
      this.text = text
      this.timeout = timeout
      this.visible = true
    },

    hide() {
      this.color = null
      this.text = null
      this.timeout = 6000
      this.visible = false
    },

    success(message, timeout = 6000) {
      this.show("success", message, timeout)
    },

    warning(message, timeout = 10000) {
      this.show("warning", message, timeout)
    },

    error(message, timeout = 0) {
      this.show("error", message, timeout)
    },
  },

  mounted() {
    bus.$on("notification:success", this.success)
    bus.$on("notification:warning", this.warning)
    bus.$on("notification:error", this.error)
  },

  destroyed() {
    bus.$off("notification:success", this.success)
    bus.$off("notification:warning", this.warning)
    bus.$off("notification:error", this.error)
  },
}
